import React from 'react'
import PropTypes from 'prop-types'
import TemplateOne from './templates/TemplateOne'
import TemplateTwo from './templates/TemplateTwo'
import TemplateThree from './templates/TemplateThree'
import TemplateFour from './templates/TemplateFour'

const TEMPLATE_BY_VARIANT = {
    'template-one': TemplateOne,
    'template-two': TemplateTwo,
    'template-three': TemplateThree,
    'template-four': TemplateFour,
}

const MenuTemplate = ({primarycategory, categoryData, locale, variant}) => {
    const Template = TEMPLATE_BY_VARIANT[variant]

    if (!Template) return null

    return (
        <Template primarycategory={primarycategory} categoryData={categoryData} locale={locale} />
    )
}

MenuTemplate.propTypes = {
    primarycategory: PropTypes.object,
    categoryData: PropTypes.object,
    locale: PropTypes.object,
    variant: PropTypes.oneOf(['template-one', 'template-two', 'template-three', 'template-four'])
        .isRequired,
}

export {MenuTemplate}
